import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverTrigger, PopoverContent } from "@heroui/react";
import { TokenConfigType } from "@/constants/types/currency";
import type { SocialsConfigType } from "@/constants/project-specific/types";
import { TokenStats } from "@/lib/price-data/getTokenStats";
import { formatPrice } from "@/util/portfolio/formatPrice";
import { ReactElement } from "react";
import { SocialIcon } from "react-social-icons";
interface TokenStatsPopoverProps {
  token: TokenConfigType;
  tokenStats?: TokenStats;
  children: ReactElement;
}
export default function TokenStatsPopover(t0) {
  const $ = _c(124);
  const {
    token,
    tokenStats,
    children
  } = t0;
  if (!tokenStats) {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const socials = token.socials;
  let t1;
  if ($[2] !== socials) {
    t1 = socials && Object.keys(socials).length > 0;
    $[2] = socials;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasSocials = t1;
  const getSocialLinks = _temp2;
  let t2;
  if ($[4] !== children) {
    t2 = <PopoverTrigger>{children}</PopoverTrigger>;
    $[4] = children;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== token.logo || $[7] !== token.symbol) {
    t3 = <img src={token.logo} alt={token.symbol} className="w-8 h-8 rounded-full" />;
    $[6] = token.logo;
    $[7] = token.symbol;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== token.symbol) {
    t4 = <h3 className="font-medium">{token.symbol}</h3>;
    $[9] = token.symbol;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== token.name) {
    t5 = <p className="text-sm text-gray-400">{token.name}</p>;
    $[11] = token.name;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="flex items-center gap-2">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== hasSocials || $[20] !== socials) {
    t8 = hasSocials && <div className="flex items-center gap-2 pt-2 border-t border-gray-700">{getSocialLinks(socials).map(_temp3)}</div>;
    $[19] = hasSocials;
    $[20] = socials;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-gray-400">Price</span>;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== tokenStats.price) {
    t10 = formatPrice(tokenStats.price);
    $[23] = tokenStats.price;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <div className="flex justify-between">{t9}{" "}<span>${t10}</span></div>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-gray-400">24h Change</span>;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const t13 = tokenStats.priceChange.h24 >= 0 ? "text-green-500" : "text-red-500";
  const t14 = tokenStats.priceChange.h24 >= 0 ? "+" : "";
  let t15;
  if ($[28] !== tokenStats.priceChange.h24) {
    t15 = tokenStats.priceChange.h24.toFixed(2);
    $[28] = tokenStats.priceChange.h24;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t14 || $[32] !== t15) {
    t16 = <div className="flex justify-between">{t12}{" "}<span className={t13}>{t14}{t15}%</span></div>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-gray-400">24h Volume</span>;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== tokenStats.volume.h24) {
    t18 = formatPrice(tokenStats.volume.h24);
    $[35] = tokenStats.volume.h24;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t18) {
    t19 = <div className="flex justify-between">{t17}{" "}<span>${t18}</span></div>;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-gray-400">FDV</span>;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== tokenStats.fdvUsd) {
    t21 = formatPrice(tokenStats.fdvUsd);
    $[40] = tokenStats.fdvUsd;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t21) {
    t22 = <div className="flex justify-between">{t20}{" "}<span>${t21}</span></div>;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="text-gray-400">Total Reserve</span>;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== tokenStats.totalReserveInUsd) {
    t24 = formatPrice(tokenStats.totalReserveInUsd);
    $[45] = tokenStats.totalReserveInUsd;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t24) {
    t25 = <div className="flex justify-between">{t23}{" "}<span>${t24}</span></div>;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <h4 className="text-sm font-medium mb-2">Price Changes</h4>;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-gray-400">5m</span>;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  const t28 = tokenStats.priceChange.m5 >= 0 ? "text-green-500" : "text-red-500";
  const t29 = tokenStats.priceChange.m5 >= 0 ? "+" : "";
  let t30;
  if ($[51] !== tokenStats.priceChange.m5) {
    t30 = tokenStats.priceChange.m5.toFixed(2);
    $[51] = tokenStats.priceChange.m5;
    $[52] = t30;
  } else {
    t30 = $[52];
  }
  let t31;
  if ($[53] !== t28 || $[54] !== t29 || $[55] !== t30) {
    t31 = <div>{t27}<span className={t28}>{" "}{t29}{t30}%</span></div>;
    $[53] = t28;
    $[54] = t29;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <span className="text-gray-400">1h</span>;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  const t33 = tokenStats.priceChange.h1 >= 0 ? "text-green-500" : "text-red-500";
  const t34 = tokenStats.priceChange.h1 >= 0 ? "+" : "";
  let t35;
  if ($[58] !== tokenStats.priceChange.h1) {
    t35 = tokenStats.priceChange.h1.toFixed(2);
    $[58] = tokenStats.priceChange.h1;
    $[59] = t35;
  } else {
    t35 = $[59];
  }
  let t36;
  if ($[60] !== t33 || $[61] !== t34 || $[62] !== t35) {
    t36 = <div>{t32}<span className={t33}>{" "}{t34}{t35}%</span></div>;
    $[60] = t33;
    $[61] = t34;
    $[62] = t35;
    $[63] = t36;
  } else {
    t36 = $[63];
  }
  let t37;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <span className="text-gray-400">6h</span>;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  const t38 = tokenStats.priceChange.h6 >= 0 ? "text-green-500" : "text-red-500";
  const t39 = tokenStats.priceChange.h6 >= 0 ? "+" : "";
  let t40;
  if ($[65] !== tokenStats.priceChange.h6) {
    t40 = tokenStats.priceChange.h6.toFixed(2);
    $[65] = tokenStats.priceChange.h6;
    $[66] = t40;
  } else {
    t40 = $[66];
  }
  let t41;
  if ($[67] !== t38 || $[68] !== t39 || $[69] !== t40) {
    t41 = <div>{t37}<span className={t38}>{" "}{t39}{t40}%</span></div>;
    $[67] = t38;
    $[68] = t39;
    $[69] = t40;
    $[70] = t41;
  } else {
    t41 = $[70];
  }
  let t42;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <span className="text-gray-400">24h</span>;
    $[71] = t42;
  } else {
    t42 = $[71];
  }
  const t43 = tokenStats.priceChange.h24 >= 0 ? "text-green-500" : "text-red-500";
  const t44 = tokenStats.priceChange.h24 >= 0 ? "+" : "";
  let t45;
  if ($[72] !== tokenStats.priceChange.h24) {
    t45 = tokenStats.priceChange.h24.toFixed(2);
    $[72] = tokenStats.priceChange.h24;
    $[73] = t45;
  } else {
    t45 = $[73];
  }
  let t46;
  if ($[74] !== t43 || $[75] !== t44 || $[76] !== t45) {
    t46 = <div>{t42}<span className={t43}>{" "}{t44}{t45}%</span></div>;
    $[74] = t43;
    $[75] = t44;
    $[76] = t45;
    $[77] = t46;
  } else {
    t46 = $[77];
  }
  let t47;
  if ($[78] !== t31 || $[79] !== t36 || $[80] !== t41 || $[81] !== t46) {
    t47 = <div className="pt-2 border-t border-gray-700">{t26}<div className="grid grid-cols-2 gap-2">{t31}{t36}{t41}{t46}</div></div>;
    $[78] = t31;
    $[79] = t36;
    $[80] = t41;
    $[81] = t46;
    $[82] = t47;
  } else {
    t47 = $[82];
  }
  let t48;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <h4 className="text-sm font-medium mb-2">Volume</h4>;
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  let t49;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <span className="text-gray-400">5m</span>;
    $[84] = t49;
  } else {
    t49 = $[84];
  }
  let t50;
  if ($[85] !== tokenStats.volume.m5) {
    t50 = formatPrice(tokenStats.volume.m5);
    $[85] = tokenStats.volume.m5;
    $[86] = t50;
  } else {
    t50 = $[86];
  }
  let t51;
  if ($[87] !== t50) {
    t51 = <div>{t49}{" "}<span>${t50}</span></div>;
    $[87] = t50;
    $[88] = t51;
  } else {
    t51 = $[88];
  }
  let t52;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <span className="text-gray-400">1h</span>;
    $[89] = t52;
  } else {
    t52 = $[89];
  }
  let t53;
  if ($[90] !== tokenStats.volume.h1) {
    t53 = formatPrice(tokenStats.volume.h1);
    $[90] = tokenStats.volume.h1;
    $[91] = t53;
  } else {
    t53 = $[91];
  }
  let t54;
  if ($[92] !== t53) {
    t54 = <div>{t52}{" "}<span>${t53}</span></div>;
    $[92] = t53;
    $[93] = t54;
  } else {
    t54 = $[93];
  }
  let t55;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <span className="text-gray-400">6h</span>;
    $[94] = t55;
  } else {
    t55 = $[94];
  }
  let t56;
  if ($[95] !== tokenStats.volume.h6) {
    t56 = formatPrice(tokenStats.volume.h6);
    $[95] = tokenStats.volume.h6;
    $[96] = t56;
  } else {
    t56 = $[96];
  }
  let t57;
  if ($[97] !== t56) {
    t57 = <div>{t55}{" "}<span>${t56}</span></div>;
    $[97] = t56;
    $[98] = t57;
  } else {
    t57 = $[98];
  }
  let t58;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <span className="text-gray-400">24h</span>;
    $[99] = t58;
  } else {
    t58 = $[99];
  }
  let t59;
  if ($[100] !== tokenStats.volume.h24) {
    t59 = formatPrice(tokenStats.volume.h24);
    $[100] = tokenStats.volume.h24;
    $[101] = t59;
  } else {
    t59 = $[101];
  }
  let t60;
  if ($[102] !== t59) {
    t60 = <div>{t58}{" "}<span>${t59}</span></div>;
    $[102] = t59;
    $[103] = t60;
  } else {
    t60 = $[103];
  }
  let t61;
  if ($[104] !== t51 || $[105] !== t54 || $[106] !== t57 || $[107] !== t60) {
    t61 = <div className="pt-2 border-t border-gray-700">{t48}<div className="grid grid-cols-2 gap-2">{t51}{t54}{t57}{t60}</div></div>;
    $[104] = t51;
    $[105] = t54;
    $[106] = t57;
    $[107] = t60;
    $[108] = t61;
  } else {
    t61 = $[108];
  }
  let t62;
  if ($[109] !== t11 || $[110] !== t16 || $[111] !== t19 || $[112] !== t22 || $[113] !== t25 || $[114] !== t47 || $[115] !== t61) {
    t62 = <div className="space-y-2">{t11}{t16}{t19}{t22}{t25}{t47}{t61}</div>;
    $[109] = t11;
    $[110] = t16;
    $[111] = t19;
    $[112] = t22;
    $[113] = t25;
    $[114] = t47;
    $[115] = t61;
    $[116] = t62;
  } else {
    t62 = $[116];
  }
  let t63;
  if ($[117] !== t62 || $[118] !== t7 || $[119] !== t8) {
    t63 = <PopoverContent className="px-8 pb-4"><div className="space-y-4">{t7}{t8}{t62}</div></PopoverContent>;
    $[117] = t62;
    $[118] = t7;
    $[119] = t8;
    $[120] = t63;
  } else {
    t63 = $[120];
  }
  let t64;
  if ($[121] !== t2 || $[122] !== t63) {
    t64 = <Popover placement="top">{t2}{t63}</Popover>;
    $[121] = t2;
    $[122] = t63;
    $[123] = t64;
  } else {
    t64 = $[123];
  }
  return t64;
}
function _temp3(url_0) {
  return <div key={url_0} className="opacity-50 hover:opacity-100 active:opacity-100 transition-opacity"><SocialIcon target="_blank" url={url_0} style={{
      height: 20,
      width: 20
    }} /></div>;
}
function _temp2(socials_0) {
  const links = [];
  if (socials_0.website) {
    links.push(socials_0.website);
  }
  if (socials_0.other) {
    links.push(...socials_0.other.filter(_temp));
  }
  return links;
}
function _temp(url) {
  return url.includes("x.com") || url.includes("twitter.com") || url.includes("t.me") || url.includes("discord.com");
}